// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_uw-0";
export var checkoutRateBadgeLink = "_uw-1";